import { AbstractControl, ValidatorFn } from '@angular/forms';

export function PasswordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const password = control.value as string;

    if (!password) {
      return null;
    }

    const isValid = password.length >= 8
      && /[A-Z]/.test(password)
      && /[a-z]/.test(password)
      && /[0-9]/.test(password)
      && /[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]/.test(password);

    return isValid ? null : { passwordPolicy: true };
  };
}
